module.exports = __webpack_public_path__ + "img/about-4.3a1e97af.png";